import React, { useCallback } from 'react';
import styles from '@/interface/ui/_shared/modal/index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { storeMarket } from '@/constants/app';

interface Props {
  onPress?: () => void;
  children?: JSX.Element;
  title?: JSX.Element;
  isStoreLink?: boolean;
  osType?: string;
}

export const Modal: React.FC<Props> = ({
  onPress,
  children,
  title,
  isStoreLink,
  osType,
}) => {
  const renderModalContent = useCallback(() => {
    const osLink =
      osType === 'Mac OS' || osType === 'iOS'
        ? storeMarket.appleStoreUrl
        : storeMarket.googlePlayUrl;

    return (
      <div className={styles.modalContentWrapper}>
        <p className={styles.modalContent}>
          atmosアプリでこちらの機能が使えます
        </p>

        <a
          href={osLink}
          target="_blank"
          rel="noreferrer"
          className={styles.buttonWrapper}
        >
          <p className={styles.buttonTitle}>アプリダウンロード</p>
        </a>
      </div>
    );
  }, [osType]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modalShow}>
        <div className={styles.modalHeaderWrapper}>
          {title}
          <FontAwesomeIcon
            icon="times"
            color="#777"
            size="sm"
            onClick={onPress}
            className={styles.closeIcon}
          />
        </div>
        {isStoreLink ? renderModalContent() : children}
      </div>
    </div>
  );
};
